module.exports = __webpack_public_path__ + "img/1485908641.028e5570.jpg";